module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-a1f7601531a90cd071d24c59297d673a.png";